export const description =
  "Mon Accompagnateur Rénov' (MAR) : opérateur agréé par l'Anah, obligatoire pour MaPrimeRénov’ Accompagné. Missions, coût, comment trouver un MAR près de chez vous en 2026.";
